import { useCallback, useEffect, useRef } from "react";

export function useThrottledCallback<TArgs extends unknown[]>(cb: (...args: TArgs) => void, intervalMs: number) {
  const cbRef = useRef(cb);
  const lastRef = useRef<number | null>(null);
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    cbRef.current = cb;
  }, [cb]);

  return useCallback(
    (...args: TArgs) => {
      const now = Date.now();
      const last = lastRef.current;
      if (last == null || now - last >= intervalMs) {
        lastRef.current = now;
        cbRef.current(...args);
      } else if (!timerRef.current) {
        const remaining = intervalMs - (now - last);
        timerRef.current = setTimeout(() => {
          timerRef.current = null;
          lastRef.current = Date.now();
          cbRef.current(...args);
        }, remaining);
      }
    },
    [intervalMs],
  );
}
